import { makeStyles } from "@material-ui/core";

export const InventoryStyles = makeStyles((theme) => ({
    inventoryContainer: {
        margin: '0.5rem 0',
        width: '100%',
        '& .MuiInputLabel-root': {
            fontSize: 14
        }
    },
    inventoryRow: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        minHeight: '3rem',
        padding: '0.35rem 0',
    },
    fieldItem: {
        minWidth: 0,
        '& .MuiInputBase-root': {
            fontSize: 14,
            minHeight: 40,
        },
        '& .MuiOutlinedInput-root': {
            minHeight: 40,
        },
    },
    addItemBtn: {
        width: '100%',
        justifyContent: 'flex-start',
        paddingLeft: '0.5rem',
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRadius: 0,
        height: '3rem',
        color: theme.palette.text.secondary,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.primary.main,
        }
    },
    saveBtn: {
        minWidth: '110px',
    },
    saveContainer: {
        display: 'flex',
        width: '100%',
        marginTop: 'auto',
        paddingTop: '1rem',
        alignItems: 'center'
    },
    overwriteConfig: {
        marginLeft: '1rem',
        '& .MuiFormControlLabel-label': {
            fontSize: 14
        }
    }
}));